"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _MarkdownLinkRenderer = _interopRequireDefault(require("../../../shared/components/MarkdownRenderers/MarkdownLinkRenderer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SectionCTALink = function SectionCTALinkComponent(_ref) {
  var _ref$sliceData$primar = _ref.sliceData.primary,
      theme = _ref$sliceData$primar.theme,
      text = _ref$sliceData$primar.text,
      _ref$sliceData$primar2 = _ref$sliceData$primar.url,
      href = _ref$sliceData$primar2.url,
      target = _ref$sliceData$primar2.target,
      dataClient = _ref.dataClient;
  var ctaClasses = (0, _classnames["default"])('content-page__section-cta-link', {
    'content-page__section-cta-link--solid-green': theme === 'Solid Green',
    'content-page__section-cta-link--solid-blue': theme === 'Solid Blue',
    'content-page__section-cta-link--hollow-blue': theme === 'Hollow Blue'
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__section-cta"
  }, /*#__PURE__*/_react["default"].createElement(_MarkdownLinkRenderer["default"], {
    className: ctaClasses,
    href: href,
    title: text,
    external: target === '_blank'
  }, dataClient.renderText(text))));
};

SectionCTALink.propTypes = {
  sliceData: _propTypes["default"].shape({
    primary: _propTypes["default"].shape({
      theme: _propTypes["default"].string.isRequired,
      text: _propTypes["default"].array.isRequired,
      url: _propTypes["default"].shape({
        url: _propTypes["default"].string.isRequired
      }).isRequired
    }).isRequired
  }).isRequired,
  dataClient: _propTypes["default"].shape({}).isRequired
};
var _default = SectionCTALink;
exports["default"] = _default;